import React, { useEffect, useState} from "react";
import { Line, Chart, Bar } from "react-chartjs-2";
import zoomPlugin from "chartjs-plugin-zoom";
import annotationPlugin from "chartjs-plugin-annotation";
import options from './ChartComponentOptionsOld'
import BinButtons from '../../history/BinButtons'
import {convertFullDateLabeltoMonthAndHour, getStandardDeviation, calculateEachMeanofArrayElement } from '../../history/ArrayFunctions'
import moment from "moment";
import ChartSettingSliders from '../../history/ChartSettingSliders'

Chart.register(annotationPlugin);
Chart.register(zoomPlugin);
// min and max slider in isimleri yanıltmasın, min en sonda olan, max ise geçmişe gidebilmemize yardım eder.
const ChartComponent = ({
  fetchedDataValue,
  fetchedDataLabel,
  title,
  ChangeMainDataType,
  titles
}) => {
 const [dataValue, setDataValue] = useState([])
 const [dataLabel, setDataLabel] = useState([])
 const [binType, setBinType] = useState([])


// const [chartNoConnectionAreas, setChartNoConnectionAreas] = useState([]);

    useEffect(() => {
        let mockupValue = fetchedDataValue;
        let mockupLabel = fetchedDataLabel;
        let holdingBinValue = [];
        let holdingBinLabel = [];
        if(binType === "standard"){
            setDataValue(fetchedDataValue)
            setDataLabel(convertFullDateLabeltoMonthAndHour(fetchedDataLabel))
        }
        else{
        for(let i=0; i< mockupLabel.length; i++){
        let mean = mockupValue[i];
        let j = 1;
        let counterOfWhileLoop = 1;
        let date = mockupLabel[i];
        while(true){
        if( moment(mockupLabel[i]).isSame(mockupLabel[i+j], binType)){
            mean = (mockupValue[i+j] + mean * counterOfWhileLoop) / (counterOfWhileLoop+1)
            j++;
            counterOfWhileLoop++;
           if((i+j+1) > (mockupLabel.length)){
            holdingBinValue.push(mean);
            holdingBinLabel.push(date);
            break;
           }
           
        }else{         
            holdingBinValue.push(mean);
            holdingBinLabel.push(date);
            break;
        }
        }
        i = i + j - 1;
        
        }

        setDataValue(holdingBinValue)
        setDataLabel(convertFullDateLabeltoMonthAndHour(holdingBinLabel)) 
        }
     
    },[binType, fetchedDataValue, fetchedDataLabel]);


function funcSetBinType(receivedBinType){
    setBinType(receivedBinType)
}


  useEffect(() => {

  if(dataValue.length > 1000)
  {
    setBorderWidthValueMean(0.01)
    setChartPointRadiusValueMean(1)
  }else if(dataValue.length > 100){
    setBorderWidthValueMean(0.5)
    setBorderWidthValue(1)
    setChartPointRadiusValueMean(1)
  }
  else{
    setBorderWidthValueMean(2.5)
    setBorderWidthValue(2.5)
    setChartPointRadiusValueMean(2.5)
  }
    
  }, [dataValue]);

  const [borderWidthValueMean, setBorderWidthValueMean] = useState(2.5);
  const [borderWidthValue, setBorderWidthValue] = useState(2.5);
  const [chartPointRadiusValueMean, setChartPointRadiusValueMean] = useState(2.5);

  return (
<div
    style={{
      height: "70vh",
      width: "70vw",
      alignItems: "center",
      alignContent: "center",
      alignSelf: "center",
      position:"relative",
    }} 
>

    <BinButtons funcSetBinType= {funcSetBinType} ChangeMainDataType = {ChangeMainDataType}  titles={titles} />
        <Bar
             style={{
              height: "70vh",
              width: "70vw",
              alignItems: "center",
              alignContent: "center",
              alignSelf: "center",
              position:"relative",
            }} 
          data={{
            labels: dataLabel,
            datasets: [
              {
                type: "line",
                label: `Mean of the ${title}`,
                data: calculateEachMeanofArrayElement(dataValue),
                borderColor: "rgb(34, 233, 226)",
                color:"rgb(34, 233, 226)",
                backgroundColor:"rgba(34, 233, 226,0.3)",
                showLine: true,
                pointRadius: chartPointRadiusValueMean,
                hoverRadius: 7,
                hoverBorderWidth: 7,
                borderWidth: borderWidthValueMean,
              },
              {
                label: `${title}`,
                data: dataValue,
                borderColor: "rgb(11, 84, 223)",
                backgroundColor: "rgba(11, 84, 223, 0.35)",
                hoverRadius: 7,
                hoverBorderWidth: 7,
              },
            ],
          }}
          options={options(borderWidthValue, 
            (dataValue.length ? dataValue.reduce((a, b) => Math.max(a, b)) : 0), 
            (dataValue.length ? dataValue.reduce((a, b) => Math.min(a, b)) : 0), 
            getStandardDeviation(dataValue), 
            title, 
            )}
        />
       
      </div>
  );
};
export default ChartComponent;
